import { initializeRecaptcha } from '../utils/recaptcha';

$(() => {
  initializeRecaptcha();

  document.body.addEventListener('htmx:afterRequest', function (evt) {

    // TODO clean up this duplicated code (maybe export from select_field.js)
    const targetError = evt.target.attributes.getNamedItem('hx-target-error')
    if (evt.detail.failed && targetError) {
      $(targetError.value).show()
    }
    const initializeSelect = (select) => {
      const input = $(select).find('input.select-field__input');
      const options = $(select).find('.select-field__dropdown-item');
      const display = $(select).find('.select-field__value');
      const dropdown = $(select).find('.select-field__dropdown');
      const placeholder = display.text();
      const autoselect = $(select).attr('data-autoselect') === 'True';

      const updateDisplay = (selected) => {
        const newText = selected;
        display.text(newText);
        display.attr('selected-country', newText.trim());
      };

      const updateInput = (selected, emit = true) => {
        const newValue = selected;
        input.attr('value', newValue);
        input.trigger('change');
        if (emit) {
          const event = new CustomEvent('selectChange', {
            detail: { value: newValue },
          });
          input.get(0).dispatchEvent(event);
        }
      };

      dropdown.on('mousedown', (event) => {
        const $target = $(event.target);
        if ($target.hasClass('select-field__dropdown-item')) {
          updateDisplay($target.text());
          updateInput($target.attr('data-option-value'));
          $(select).find('.selected').removeClass('selected');
          $target.addClass('selected');
        }
      });
      display.on('click', () => {
        dropdown.toggleClass('hide');
      });
      display.on('blur', () => {
        dropdown.addClass('hide');
      });
      (function updateSavedOption() {
        options.each((_, option) => {
          if (option.classList.contains('selected')) {
            updateDisplay(option.textContent);
            updateInput(option.dataset.optionValue);
          }
        });
      })();
      input.on('clearSelect', (_, emit = true) => {
        updateDisplay(placeholder);
        updateInput('', emit);
        $(select).find('.selected').removeClass('selected');
      });

      // trigger selecting first option if autoselect set
      if (autoselect) {
        options.first().trigger('mousedown');
      }
    };


    const selects = $('.select-field');
    selects.each((_, select) => initializeSelect(select));
  });

})

